import type { ApplicationDownPaymentRequest } from "@amsanalytics/react-shared-library";
import { PaymentProcessor } from '../Interfaces/Common/PaymentProcessor';

// URL presence is the only signal that a payment link was issued: AMS payment responses are not
// linked back to the request that generated them, so there is no per-link "consumed" state.
// Type-only import above keeps this module free of the shared-library runtime bundle so it stays
// testable under Jest, which cannot parse that bundle's Kendo dependencies.
export const getDownPaymentRequestsWithLink = (applicationDownPaymentRequests: ApplicationDownPaymentRequest[]): ApplicationDownPaymentRequest[] => {
  return applicationDownPaymentRequests.filter(dpr => !!dpr.url?.trim());
}

/**
 * True when the selected payment processor's payment page has to be opened in a new tab.
 *
 * Some processors (PayNearMe, BlytzPay) send X-Frame-Options: sameorigin and refuse to load inside
 * the down payment dialog's iframe. Which processors do that is stored on los.PaymentProcessor.OpenInNewTab
 * and comes to the client through the lookups, so no processor GUIDs are hardcoded here.
 *
 * GUID casing is ignored because the API serializes GUIDs in lower case while other client code uses upper case.
 * An unknown processor, no selection, or lookups that have not loaded all fall back to the iframe.
 */
export const paymentProcessorOpensInNewTab = (
  paymentProcessors: PaymentProcessor[] | undefined | null,
  paymentProcessorId: string | undefined | null
): boolean => {
  if (!paymentProcessorId || !paymentProcessors) return false;

  const processorId = paymentProcessorId.toLowerCase();
  return paymentProcessors.find(pp => pp.id.toLowerCase() === processorId)?.openInNewTab === true;
};
